import React, { memo } from 'react';
import { FormStep } from '../../../model/global';

interface Props {
	currentStep: number;
	totalSteps: number;
	step: Pick<FormStep, 'stepTitle' | 'stepInfo'>;
}

const FormStepTitle: React.FC<Props> = props => {

	const { currentStep, totalSteps, step } = props

	const stepIndicator: {
		fractionTop: string;
		fractionBottom: string;
	} = {
		fractionTop: (currentStep + 1).toString().padStart(2, '0'),
		fractionBottom: (totalSteps).toString().padStart(2, '0'),
	}

	const ukPosition = step?.stepInfo?.helpButton ? 'uk-flex-bottom' : 'uk-flex-middle';
	const stepInfoClassName = "a-button m-formstep-step-title__more-info uk-visible@l uk-button uk-flex-inline uk-flex-middle uk-text-center uk-button-ghost has-icon has-no-text extra-info"

	return (
		<div className={`title-section ${ukPosition}`}>
			<div className={'headline'}>
				{step?.stepTitle && <h2 className={'title'}>{step?.stepTitle}</h2>}
				<div className="uk-flex">

					{step?.stepInfo?.copy && <div className={'copy'}>
						{step.stepInfo.copy}
					</div>}

					{step?.stepInfo?.helpButton &&
						<a
							className={stepInfoClassName}
							data-controller="ControllerButton"
							href="#"
							target="_self"
							title={
								step?.stepInfo?.helpButton?.title
									? step?.stepInfo?.helpButton?.title
									: ''
							}
						>
							<span className="a-button__icon-wrapper uk-icon"
								data-uk-icon={step?.stepInfo?.helpButton?.icon}>
							</span>
							<div className="a-button__extraInfo">
								{step?.stepInfo?.helpButton?.title}
							</div>
						</a>
					}
				</div>
			</div>
			{(stepIndicator?.fractionTop && stepIndicator?.fractionBottom) &&
				<div className={'step'}>
					<strong>{stepIndicator.fractionTop}</strong>/{stepIndicator.fractionBottom}
				</div>
			}
		</div>
	);
};

export default memo(FormStepTitle);
